import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { MENU_ROUTES } from '../utils/constants/routes';
import '../styles/layouts/not-found.scss';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="sys-not-found">
      <div className="center">
        <div className="error">
          <div className="number">4</div>
          <div className="illustration">
            <div className="circle"></div>
            <div className="clip">
              <div className="paper">
                <div className="face">
                  <div className="eyes">
                    <div className="eye eye-left"></div>
                    <div className="eye eye-right"></div>
                  </div>
                  <div className="rosyCheeks rosyCheeks-left"></div>
                  <div className="rosyCheeks rosyCheeks-right"></div>
                  <div className="mouth"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="number">4</div>
        </div>

        <div className="text">おっと、お探しのページは存在しません。</div>
        <Button type="primary" autoInsertSpace={false} onClick={() => navigate(MENU_ROUTES.HOME)}>
          ホームに戻る
        </Button>
      </div>
    </div>
  );
};

export default NotFoundPage;
